/** Helpers for unit-block countdown (voucher `blockedUnit` uses expiry or createdAt + duration). */

export const secondsRemainingUntil = (expiryAtMs) =>
  Math.max(0, Math.floor((expiryAtMs - Date.now()) / 1000));

export function parsePositiveMinutes(value) {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return Math.floor(n);
}

/**
 * Payment window end for customer voucher `blockedUnit`.
 * Prefers `unitBlockExpiry`; else `createdAt` + `unitBlockDuration` minutes; else duration from now.
 */
export function getVoucherBlockedUnitWindowEndMs(blockedUnit) {
  if (!blockedUnit || typeof blockedUnit !== "object") {
    return null;
  }
  if (blockedUnit.unitBlockExpiry) {
    const ms = Date.parse(blockedUnit.unitBlockExpiry);
    if (Number.isFinite(ms)) {
      return ms;
    }
  }
  const durationMin = parsePositiveMinutes(blockedUnit.unitBlockDuration);
  const createdMs = blockedUnit.createdAt
    ? Date.parse(blockedUnit.createdAt)
    : Number.NaN;
  if (Number.isFinite(createdMs) && durationMin != null) {
    return createdMs + durationMin * 60 * 1000;
  }
  if (durationMin != null) {
    return Date.now() + durationMin * 60 * 1000;
  }
  return null;
}
